<template>
  <div class="pt-10 pb-5 component-div">
    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
            <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
          </div>
        </b-col>
      </b-row>

      <b-row class="pl-32 pt-10">
        <div class="activity_add_edit_index col-md-12 clearfix">
          <div class="row">
            <div class="form-group col-md-3 p-0 rows_label_div rows_label_position">
              <!-- <label>Rows</label> -->
              <div v-for="(rowName, i) in componentData.rows" :key="i + '_row'">
                <input :id="componentData.sequence + '_rowINDEX' + i" :value="indexQuestionValue(`${translationKeyInitial}_rows_${i}_row`, componentData.rows[i], true)" class="form-control Column_preview" placeholder="Enter label" readonly />
                <b-tooltip :target="componentData.sequence + '_rowINDEX' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_rows_${i}_row`, componentData.rows[i], false) }}</b-tooltip>
              </div>
            </div>
            <div class="form-group col-md-9 p-0 rows_label_div">
              <div class="row">
                <div class="col-md-4 p-0 mr-5" v-for="(colName, i) in componentData.cols" :key="i + '_col'">
                  <!-- <label>Columns</label> -->
                  <input readonly :id="componentData.sequence + '_collabel' + i" :value="indexQuestionValue(`${translationKeyInitial}_cols_${i}_col`, componentData.cols[i], true)" class="form-control Column_preview" placeholder="Enter label" />
                  <b-tooltip :target="componentData.sequence + '_collabel' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_cols_${i}_col`, componentData.cols[i], false) }}</b-tooltip>
                  <div v-for="(rowName, j) in componentData.rows" :key="j + '_row'">
                    <input readonly @click="selectIndexCell(i, j)" :id="componentData.sequence + '_rowcol' + j + 'row' + i" :value="indexQuestionValue(`${translationKeyInitial}_indexValues_${j}_indexValue_${i}_value`, componentData.indexValues[j][i].value, true)" class="form-control" placeholder="Enter value" :class="isFieldDisabled == true ? 'no-click' : ''" />
                    <b-tooltip :target="componentData.sequence + '_rowcol' + j + 'row' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_indexValues_${j}_indexValue_${i}_value`, componentData.indexValues[j][i].value, false) }}</b-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            :class="isFieldDisabled ? 'disable-question' : ''"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            v-if="componentData.isSkippable"
            :class="isFieldDisabled ? 'disable-question' : ''"
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <span v-if="hasFieldError" class="text-danger pl-5 fw-bold">{{ fieldErrorText }}</span>
          <span class="text-warning pl-5 fw-bold" v-else-if="hasFieldWarning">{{ fieldWarningText }}</span>
        </b-col>
      </b-row>

      <b-row class="mb-12 mt-5 pl-43" :class="isFieldDisabled ? 'disable-question' : ''">
        <div class="activity_add_edit_index col-md-12 p-0 clearfix">
          <div class="row">
            <div :class="completeEdit == true ? 'col-md-4' : 'col-md-3'" class="form-group p-0 rows_label_div rows_label_position">
              <!-- <label>Rows</label> -->
              <div v-for="(rowName, i) in componentData.rows" :key="i + '_row'">
                <input readonly :id="componentData.sequence + '_rowINDEX' + i" :value="indexQuestionValue(`${translationKeyInitial}_rows_${i}_row`, componentData.rows[i], true)" class="form-control Column_preview" placeholder="Enter label" />
                <b-tooltip :target="componentData.sequence + '_rowINDEX' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_rows_${i}_row`, componentData.rows[i], false) }}</b-tooltip>
              </div>
            </div>
            <div :class="completeEdit == true ? 'col-md-8' : 'col-md-9'" class="form-group p-0 rows_label_div mb-0">
              <div class="row">
                <div :class="completeEdit == true ? 'col-md-4' : 'col-md-3'" class="p-0 mr-5" v-for="(colName, i) in componentData.cols" :key="i + '_col'">
                  <!-- <label>Columns</label> -->
                  <input readonly class="form-control Column_preview" :id="componentData.sequence + '_collabel' + i" :value="indexQuestionValue(`${translationKeyInitial}_cols_${i}_col`, componentData.cols[i], true)" placeholder="Enter label" />
                  <b-tooltip :target="componentData.sequence + '_collabel' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_cols_${i}_col`, componentData.cols[i], false) }}</b-tooltip>
                  <div class="hovermousepointer" v-for="(rowName, j) in componentData.rows" :key="j + '_row'">
                    <input
                      :class="[{ borderSelect: isCellSelected(j, i) === true }, { 'no-click': isFieldDisabled == true }]"
                      readonly
                      @click="selectIndexCell(j, i)"
                      :id="componentData.sequence + '_rowcol' + j + 'row' + i"
                      :value="indexQuestionValue(`${translationKeyInitial}_indexValues_${j}_indexValue_${i}_value`, componentData.indexValues[j][i].value, true)"
                      class="form-control"
                      placeholder="Enter value"
                    />
                    <b-tooltip :target="componentData.sequence + '_rowcol' + j + 'row' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_indexValues_${j}_indexValue_${i}_value`, componentData.indexValues[j][i].value, false) }}</b-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>
      <div :class="isFieldDisabled ? 'disable-question' : ''">
        <span class="activity-form__clear pl-43" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label class="fs-12" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            {{ componentData.actualScore || showScore(componentData.skipScore) }}
          </div>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
        </b-col>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-12'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div class="activity_add_edit_index col-md-12 clearfix">
            <div class="row">
              <div class="form-group col-md-4 p-0 rows_label_div rows_label_position">
                <!-- <label>Rows</label> -->
                <div v-for="(rowName, i) in componentData.rows" :key="i + '_row'">
                  <input readonly :id="componentData.sequence + '_rowINDEX' + i" :value="indexQuestionValue(`${translationKeyInitial}_rows_${i}_row`, stripHtml(componentData.rows[i]), true)" class="form-control Column_preview" placeholder="Enter label" />
                  <b-tooltip :target="componentData.sequence + '_rowINDEX' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_rows_${i}_row`, stripHtml(componentData.rows[i]), false) }}</b-tooltip>
                </div>
              </div>
              <div class="form-group col-md-8 p-0 rows_label_div">
                <div class="row">
                  <div class="col-md-4 p-0 mr-5" v-for="(colName, i) in componentData.cols" :key="i + '_col'">
                    <!-- <label>Columns</label> -->
                    <input readonly class="form-control Column_preview" :id="componentData.sequence + '_collabel' + i" :value="indexQuestionValue(`${translationKeyInitial}_cols_${i}_col`, componentData.cols[i], true)" placeholder="Enter label" />
                    <b-tooltip :target="componentData.sequence + '_collabel' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_cols_${i}_col`, componentData.cols[i], false) }}</b-tooltip>
                    <div v-for="(rowName, j) in componentData.rows" :key="j + '_row'">
                      <input :class="[{ borderSelect: isCellSelected(j, i) === true }, { 'no-click': isFieldDisabled == true }]" readonly :id="componentData.sequence + '_rowcol' + j + 'row' + i" :value="indexQuestionValue(`${translationKeyInitial}_indexValues_${j}_indexValue_${i}_value`, componentData.indexValues[j][i].value, true)" class="form-control" placeholder="Enter value" />
                      <b-tooltip :target="componentData.sequence + '_rowcol' + j + 'row' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_indexValues_${j}_indexValue_${i}_value`, componentData.indexValues[j][i].value, false) }}</b-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
              <!-- <span v-if="componentData.excludeScore" class="ml-10">Score excluded from total</span> -->
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            class="answers previous-value"
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
          >
            Previous value
          </div>
          <div class="activity_add_edit_index col-md-12 clearfix">
            <div class="row">
              <div class="form-group col-md-3 p-0 rows_label_div rows_label_position">
                <!-- <label>Rows</label> -->
                <div v-for="(rowName, i) in componentData.rows" :key="i + '_row'">
                  <input readonly :id="componentData.sequence + '_rowINDEX' + i" :value="indexQuestionValue(`${translationKeyInitial}_rows_${i}_row`, stripHtml(componentData.rows[i]), true)" class="form-control" placeholder="Enter label" />
                  <b-tooltip :target="componentData.sequence + '_rowINDEX' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_rows_${i}_row`, stripHtml(componentData.rows[i]), false) }}</b-tooltip>
                </div>
              </div>
              <div class="form-group col-md-9 p-0 rows_label_div">
                <div class="row">
                  <div class="col-md-4 p-0 mr-5" v-for="(colName, i) in componentData.cols" :key="i + '_col'">
                    <!-- <label>Columns</label> -->
                    <input readonly class="form-control Column_preview" :id="componentData.sequence + '_collabel' + i" :value="indexQuestionValue(`${translationKeyInitial}_cols_${i}_col`, componentData.cols[i], true)" placeholder="Enter label" />
                    <b-tooltip :target="componentData.sequence + '_collabel' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_cols_${i}_col`, componentData.cols[i], false) }}</b-tooltip>
                    <div v-for="(rowName, j) in componentData.rows" :key="j + '_row'">
                      <input
                        :class="[
                          {
                            borderSelect: isCellSelectedPrevious(j, i) === true
                          },
                          { 'no-click': isFieldDisabled == true }
                        ]"
                        readonly
                        :id="componentData.sequence + '_rowcol' + j + 'row' + i"
                        :value="indexQuestionValue(`${translationKeyInitial}_indexValues_${j}_indexValue_${i}_value`, componentData.indexValues[j][i].value, true)"
                        class="form-control"
                        placeholder="Enter value"
                      />
                      <b-tooltip :target="componentData.sequence + '_rowcol' + j + 'row' + i" placement="top" triggers="hover blur">{{ indexQuestionValue(`${translationKeyInitial}_indexValues_${j}_indexValue_${i}_value`, componentData.indexValues[j][i].value, false) }}</b-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import _ from "lodash";

export default {
  name: "ActivtiyFormIndexPreview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: "",
      answerObj: {},
      selectedI: "",
      selectedJ: ""
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    completeEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isFieldDisabled(val) {
      if (val === true) {
        this.resetField();
      }
    },
    hasFieldError(val) {
      this.componentData.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.componentData.fieldErrorText = val;
    },
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.checkForFieldErrors();
      }
    }
  },
  mounted() {
    if (!this.componentData.answer) {
      this.$set(this.componentData, "answer", {});
    }

    try {
      if (this.mode == 0 || this.mode == 2) {
        if (this.componentData.isSkippable && this.componentData.answer == "") {
          this.componentData.actualScore = this.componentData.skipScore;
          this.componentData.computedScore = this.componentData.skipScore;
        } else {
          this.componentData.actualScore = this.componentData.answer.score;
          this.componentData.computedScore = this.componentData.answer.score;
        }
      }
      if (this.mode == 2) {
        if (this.componentData.isSkippable && this.componentData.answer == "") {
          this.componentData.previousActualScore = this.componentData.skipScore;
        } else {
          this.componentData.previousActualScore = this.componentData.previousAnswer.score;
        }
      }
    } catch (e) {}
    if ((this.mode == 2 || this.mode == 1) && "xIndex" in this.componentData.answer) {
      this.selectedI = this.componentData.answer.xIndex;
    }
    if ((this.mode == 2 || this.mode == 1) && "yIndex" in this.componentData.answer) {
      this.selectedJ = this.componentData.answer.yIndex;
    }
  },
  updated() {},
  methods: {
    isCellSelectedPrevious(i, j) {
      if (this.componentData.previousAnswer.xIndex == i && this.componentData.previousAnswer.yIndex == j) {
        if (this.selectedI.length == 0 && this.selectedJ.length == 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isCellSelected(i, j) {
      if (this.selectedI == i && this.selectedJ == j) {
        if (this.selectedI.length == 0 && this.selectedJ.length == 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    selectIndexCell(i, j) {
      this.selectedI = i;
      this.selectedJ = j;
      //this.answerObj = this.componentData.indexValues[j][i];
      this.componentData.actualScore = this.componentData.indexValues[this.selectedI][this.selectedJ].score;
      this.componentData.answer = {
        xIndex: this.selectedI,
        yIndex: this.selectedJ,
        score: this.componentData.indexValues[this.selectedI][this.selectedJ].score,
        value: this.componentData.indexValues[this.selectedI][this.selectedJ].value
      };
      this.onFieldChange();
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    indexQuestionValue(translation, componentData, truncate) {
      const value = this.stripHtml(this.translateToActiveLang(translation, componentData));
      let string = null;
      if (value.length > 15 && truncate) {
        string = _.cloneDeep(value);
        return string.substring(0, 15) + "...";
      }
      return string == null ? value : string;
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetField() {
      this.componentData.answer = undefined;
      this.selectedI = "";
      this.selectedJ = "";
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.componentData.dataChecks = [];

      this.resetAllErrors();
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
    },
    onFieldChange() {
      this.checkForFieldErrors();
      this.onAnswerChange();
    },
    validateCharacterLimit(answer, hasLimit, characterLimit) {
      if (hasLimit && answer.length > characterLimit) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Character limit can not be more than ${characterLimit}`, { CHAR_LIMIT: characterLimit });
        return true;
      }
      if (hasLimit == false && answer.length > 4096) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Character limit can not be more than 4096`, { CHAR_LIMIT: 4096 });
        return true;
      }
      return false;
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
    },
    checkForFieldErrors() {
      let { isSkippable, dataEditChecks } = this.componentData;
      this.componentData.dataChecks = [];
      this.resetAllErrors();
      if (dataEditChecks) {
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && (this.selectedJ === "" || this.selectedI === "")) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `This field is required.`;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: "soft",
                message: this.fieldWarningText
              });
              return false;
            }
          } else {
            if (dataEditChecks[k].type == "NOT_BLANK" && (this.selectedJ === "" || this.selectedI === "")) {
              this.hasFieldError = true;
              this.fieldErrorText = `This field is required.`;
              isSkippable = false;
            }
          }
        }
      }
      if (!isSkippable) {
        if (this.selectedJ === "" || this.selectedI === "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_value_selection", "Value selection is required.");
          return false;
        }
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.componentData.computedScore = this.componentData.answer.score;
        this.componentData.actualScore = this.componentData.answer.score;
        this.$emit("onAnswerChange", this.componentData);
      });
    },
    onSubmit() {
      this.componentData.answer = this.answerObj;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
  margin-top: -28px;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.col-md-2.rows_label_div,
.col-md-1.rows_label_div {
  position: relative;
  bottom: -35px;
}
.activity_add_edit_index .form-row {
  margin-left: 2px;
}
.add_row {
  width: 115px;
  display: block;
}
.rows_label_div .modal-content {
  width: 800px;
  padding: 70px 20px 0 20px;
  position: relative;
  bottom: 35px;
  z-index: 100;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
}
.form-group.col-md-2.p-0.rows_label_div {
  width: 12%;
}
.rows_label_div .col-md-2:first-child label {
  visibility: visible;
}
.rows_label_div .col-md-2 label {
  visibility: hidden;
}
.activity-configurator-step-edit-mode .score_cls {
  margin-left: -1%;
}
.hovermousepointer input {
  cursor: pointer !important;
}
.borderSelect {
  background-color: #4c8ce4 !important;
  color: white !important;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #4c8ce4;
}

.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.form-control {
  border-radius: 0.1rem;
  border: 1px solid #ced4da;
}
.col-md-1 .form-control,
.Column_preview,
.col-md-2 .form-control,
.col-md-3 input.form-control:disabled {
  border: none;
  color: #b0bac9 !important;
}
.col-md-1.rows_label_div .form-control,
.col-md-2 .form-control {
  padding: 0.375rem 0rem;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
.no-click {
  pointer-events: none;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
.rows_label_position {
  position: relative;
  bottom: -33px;
}
.form-control:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
